import { render, staticRenderFns } from "./MultiSellout.vue?vue&type=template&id=2ed95c96&scoped=true&"
import script from "./MultiSellout.vue?vue&type=script&lang=js&"
export * from "./MultiSellout.vue?vue&type=script&lang=js&"
import style0 from "./MultiSellout.vue?vue&type=style&index=0&id=2ed95c96&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed95c96",
  null
  
)

component.options.__file = "MultiSellout.vue"
export default component.exports